import { applyDiscovery as applyDiscoveryDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    routesData?: any,
}

export async function  applyDiscovery ({
    routesData,
    eventEmitter,
}: Props) {
    let tasksFiltered = await applyDiscoveryDiagram(routesData,false);
    if (tasksFiltered > 0) {
        eventEmitter.emit(Event.applyFilter);
        eventEmitter.emit(Event.discoveryIconActive);
        apiProvider.setDiagramVisualizer()    
        eventEmitter.emit(Event.updateGaugeMetrics);
    }
};
